type BootLogMeta = Record<string, string | number | boolean | null | undefined>;

const getBootTimestamp = () => new Date().toISOString();

export const getBootPathname = () => {
  try {
    return window.location?.pathname || '/';
  } catch {
    return '/';
  }
};

export const bootLog = (step: string, meta?: BootLogMeta) => {
  const payload = {
    ts: getBootTimestamp(),
    path: getBootPathname(),
    ...meta,
  };

  console.info('[boot]', step, payload);
};
